@let onglet = data().ongletHygieneChange;

<div class="timeline">
  @for (change of onglet.zr_change; track $index) {
  @if (change.input_heure) {
  <div class="timeline-item">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>schedule</mat-icon>{{ change.input_heure | carnetHeure }}</span>
      <span class="chips-row">
        @if (change.checkbox_urine) { <mat-chip class="chip-small">Urine</mat-chip> }
        @if (change.checkbox_selle) { <mat-chip class="chip-small">Selle</mat-chip> }
        @if (change.select_etatSelle) { <span class="muted">— {{ change.select_etatSelle }}</span> }
      </span>
    </div>
  </div>
  }
  }

  @for (soin of onglet.zr_soinComplementaire; track $index) {
  @if (soin.input_heure) {
  <div class="timeline-item soin">
    <div class="timeline-dot"></div>
    <div class="timeline-content">
      <span class="time-badge secondary"><mat-icon>medical_services</mat-icon>{{ soin.input_heure | carnetHeure }}</span>
      <span class="chips-row">
        @if (soin.checkbox_lavageNez) { <mat-chip class="chip-small">Lavage nez</mat-chip> }
        @if (soin.checkbox_lavageYeux) { <mat-chip class="chip-small">Lavage yeux</mat-chip> }
      </span>
    </div>
  </div>
  }
  }
</div>
